import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.2911 11.7316C14.155 11.7316 16.4767 9.43137 16.4767 6.59384C16.4767 3.75632 14.155 1.45605 11.2911 1.45605C8.42716 1.45605 6.10547 3.75632 6.10547 6.59384C6.10547 9.43137 8.42716 11.7316 11.2911 11.7316Z",
      stroke: "#231F20",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1 22.544V19.2811C1 16.9862 2.87759 15.126 5.19386 15.126H17.3876C19.7039 15.126 21.5815 16.9862 21.5815 19.2811V22.544",
      stroke: "#231F20",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, -1)
  ]))]))
}
export default { render: render }